import React, {lazy, Suspense} from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import HubPage from './hub/HubPage';
import HorarioPage from './apps/horario/pages/HorarioPage';
import CalendarioPage from './apps/calendario/pages/CalendarioPage';
import TpPage from './apps/tp/TpPage';
import {MAPS_ENABLED} from './apps.config';
const MapLanding = lazy(() => import('./apps/mapa/rooms/MapLanding'));
const MapRoom = lazy(() => import('./apps/mapa/rooms/MapRoom'));

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HubPage />} />
      <Route path="/horario" element={<HorarioPage />} />
      <Route path="/calendario" element={<CalendarioPage />} />
      <Route path="/TP" element={<TpPage />} />
      {MAPS_ENABLED && <>
        <Route path="/gts/mapa" element={<Suspense fallback={<p>Abrindo mapas…</p>}><MapLanding /></Suspense>} />
        <Route path="/gts/mapa/:slug" element={<Suspense fallback={<p>Abrindo sala…</p>}><MapRoom /></Suspense>} />
      </>}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
